import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';

export const TestComponent = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 9999
    }}>
      {/* Test component banner - commented out
      <div style={{ padding: '20px', background: '#f0f0f0', borderBottom: '1px solid #ddd' }}>
        <h2>Test Component - React is working</h2>
      </div>
      */}
      <div style={{ flex: 1, padding: '20px', overflow: 'auto' }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </div>
    </div>
  );
};
